module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/product-price-block/product-price-block.component.scss
// module id = ./src/app/modules/backstage-module/components/product-price-block/product-price-block.component.scss
// module chunks = 9